import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class Usp {

    constructor(el) {
        this.el = el;

        const usps = this.el.querySelectorAll('[data-usp]');
        const uspsArr = gsap.utils.toArray(usps);

        let tl = gsap.timeline()

        tl.fromTo("[data-usp='0']", {autoAlpha: 0}, {duration: 0.7, autoAlpha: 1});
        tl.fromTo("[data-usp='1']", {autoAlpha: 0}, {duration: 0.7, autoAlpha: 1});
        tl.fromTo("[data-usp='2']", {autoAlpha: 0}, {duration: 0.7, autoAlpha: 1});

        ScrollTrigger.create({
            trigger: usps,
            animation: tl,
            toggleActions: 'play none none none',
            once: true,
        });

    }
}
